import { useEffect, useMemo } from 'react';

// Custom hook to use the resize observer api,
// to observe changes in the size of an **UNIQUE** element
// Will trigger the callback with the contentRect,
// which contains width, height, top, bottom, etc of the element,
// and the html element itself, so you can query for offsetWidth, etc
export const useNativeResizeObserver = <T extends HTMLElement>(
  el: T | null,
  callback: (entry: { contentRect: DOMRectReadOnly; target: T }) => void,
) => {
  const resizeObserver = useMemo(
    () =>
      new ResizeObserver((entries) => {
        const entry = entries[0]; // We will only observe one element

        const { contentRect } = entry;

        const target = entry.target as T;

        callback({ contentRect, target });
      }),
    [callback],
  );

  useEffect(() => {
    if (el) resizeObserver.observe(el);
    return () => resizeObserver.disconnect();
  }, [el, resizeObserver]);
};
